module.exports = __webpack_public_path__ + "img/53c279ea76e4f45efc2949150254dc0c.png";